import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home'
import index from '@/pages/index/index'
import dataQuery from '@/pages/dataQuery/dataQuery'
import statisticalYearbook from '@/pages/statisticalYearbook/statisticalYearbook'
import statisticalInfo from '@/pages/statisticalInfo/statisticalInfo'
import dataReport from '@/pages/dataReport/dataReport'
import article from '@/pages/article/article'
import reportdetail from '@/pages/reportdetail/reportdetail'
Vue.use(Router)
// const routerModel = (process.env.NODE_ENV === 'development') ? 'hash' : 'history';
const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        {path: '/index', component: index, name: '首页'},
        {path: '/dataQuery', component: dataQuery, name: '数据查询'},
        {path: '/statisticalYearbook', component: statisticalYearbook, name: '统计年鉴'},
        {path: '/statisticalInfo', component: statisticalInfo, name: '文献资料'},
        {path: '/article', component: article, name: '新闻文章'},
        {path: '/dataReport', component: dataReport, name: '报表查询'},
        {path: '/reportdetail', component: reportdetail, name: '报表详情'}
      ]
    },
    
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched) {
    next()
  }
      
})
export default router




// WEBPACK FOOTER //
// ./src/router/index.js